<p>dashlet-ipnrstatus works!</p>